/**
 * @fileoverview Main React interface for link that sends a post request then switches to a cooldown
 * timer afterwards.
 */
goog.module('yext.users.PostRequestTimer');

goog.require('goog.net.XhrIo');
const {DeprecatedOldButton: Button} = goog.require('yext.ui.components.button');

exports = class PostRequestTimer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      countdown: false,
      timeRemaining: this.props.duration,
      firstClick: true,
    };
  }

  onSendRequest(e) {
    goog.net.XhrIo.send(
      this.props.url,
      this.countDown(),
      'POST',
      this.props.requestContent,
      {'x-requested-with': 'XMLHttpRequest'},
    );
    e.stopPropagation();
  }

  countDown() {
    this.setState({countdown: true});
    this.intervalId = setInterval(
      () => this.tick(),
      1000,
    );
  }

  tick() {
    this.setState({timeRemaining: this.state.timeRemaining - 1});
    if (this.state.timeRemaining <= 0) {
      this.setState({
        timeRemaining: this.props.duration,
        countdown: false,
        firstClick: false,
      });
      clearInterval(this.intervalId);
    }
  }

  render() {
    let text = this.props.text;
    if (!this.state.firstClick && this.props.showPostClickTextAfterFirstClick) {
      text = this.props.postClickText;
    }

    return (
      <div>
        <div
          tabIndex="-1"
          role="button"
          hidden={this.state.countdown}
          onKeyDown={e => e.stopPropagation()}
        >
          <Button
            chromeless={true}
            onClick={e => this.onSendRequest(e)}
          >
            {text}
          </Button>
        </div>
        <p
          className="countdown"
          hidden={!this.state.countdown}
        >
          {this.props.postClickText} ({this.state.timeRemaining}s)
        </p>
      </div>);
  }
};
